module.exports = __webpack_public_path__ + "static/media/luka_hvalec_cut.e31f8ae0.jpg";